var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 text-center"},[_c('span',{staticClass:"mt-2"},[_vm._v("Loading data")]),_vm._v(" "),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"#FB7E42"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }